import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import userCard from "../../assets/img/user/card/green/01.png";
import userCard2 from "../../assets/img/user/card/green/02.png";
import userCard3 from "../../assets/img/user/card/green/03.png";
import userCard4 from "../../assets/img/user/card/green/04.png";

import styles from "../custom.module.css";

import { getDashData } from "../../redux/actions/dashboard";
import { getWalletData } from "../../redux/actions/wallet";
import { getEarningData } from "../../redux/actions/earning";
import { getteamData } from "../../redux/actions/team";
import { getActivateUserPackages } from "../../redux/actions/package";

import formatDate from "../../utils/formatDate";

const UserData = () => {
  const dispatch = useDispatch();

  // Redux state
  const user = useSelector((state) => state.auth.user);
  const dashData = useSelector((state) => state.dashboard.dashData);
  const walletData = useSelector((state) => state.wallet.walletData);
  const earningData = useSelector((state) => state.earning.earningData);
  const teamData = useSelector((state) => state.team.teamData);
  const activeUserPackages = useSelector(
    (state) => state.packages.activeUserPackages
  );

  console.log("Dash Data : ", dashData);
  
  // Package state
  const [pkgName, setPkgName] = useState("");
  const [pkgAmount, setPkgAmount] = useState("");
  const [dailyGrowth, setdailyGrowth] = useState("");
  const [dailyCapping, setdailyCapping] = useState("");
  const [activationDate, setactivationDate] = useState("");

  // Fetch all data on mount
  useEffect(() => {
    dispatch(getDashData());
    dispatch(getWalletData());
    dispatch(getEarningData());
    dispatch(getteamData());
    dispatch(getActivateUserPackages());
  }, [dispatch]);

  // Update package details whenever activeUserPackages changes
  useEffect(() => {
    if (activeUserPackages?.length > 0) {
      const latestPackage = activeUserPackages[activeUserPackages.length - 1];
      setPkgName(latestPackage.Package.pkg_name);
      setPkgAmount(latestPackage.Package.pkg_amount);
      setdailyGrowth(latestPackage.Package.growth_per);
      setdailyCapping(latestPackage.Package.per_day_income_capping);
      setactivationDate(formatDate(latestPackage.created_on));
    } else {
      setPkgName("");
      setPkgAmount("");
      setdailyGrowth("");
      setdailyCapping("");
      setactivationDate("");
    }
  }, [activeUserPackages]);

  return (
    <div>
      {/* User details section */}
      <section className="user-ditails-wrapper fix section-bg-5 section-padding">
        <div className="container">
          <div className="row">
            {/* Total Investment & Total Earning */}
            <div className="col-xl-3 col-sm-6">
              <div className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp">
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div className={styles.twoColumns}>
                      <div className="col">
                        <div className={styles.fontMediumBold}>Total Investment</div>
                        <p>${dashData?.totalPurchaseValue || "0.00"}</p>
                      </div>
                      <div className="col">
                        <div className={styles.fontMediumBold}>Total Earning</div>
                        <p>${dashData?.totalGrowth || "0.00"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Direct Members & Direct Business */}
            <div className="col-xl-3 col-sm-6">
              <div className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp">
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard2} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div className={styles.twoColumns}>
                      <div className="col">
                        <div className={styles.fontMediumBold}>Direct Members</div>
                        <p>{dashData?.direct_referral_count || 0}</p>
                      </div>
                      <div className="col">
                        <div className={styles.fontMediumBold}>Direct Business</div>
                        <p>{teamData?.totalDirectBusiness || 0}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Team Members & Team Business */}
            <div className="col-xl-3 col-sm-6">
              <div className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp">
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard3} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div className={styles.twoColumns}>
                      <div className="col">
                        <div className={styles.fontMediumBold}>Team Members</div>
                        <p>{teamData?.summary?.totalMembers || 0}</p>
                      </div>
                      <div className="col">
                        <div className={styles.fontMediumBold}>Team Business</div>
                        <p>${teamData?.totalteamBusiness || 0}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Direct Income & Team Earning */}
            <div className="col-xl-3 col-sm-6">
              <div className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp">
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard4} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div className={styles.twoColumns}>
                      <div className="col">
                        <div className={styles.fontMediumBold}>Todays Business</div>
                        <p>${teamData?.todaysCount?.todaysBusiness || 0}</p>
                      </div>
                      <div className="col">
                        <div className={styles.fontMediumBold}> Today's Joining</div>
                        <p>{teamData?.todaysCount?.todaysJoiningCount || 0}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Wallet & Package Section */}
          <div className="row mt-4">
            {/* Total Deposit & Withdrawal */}
            <div className="col-xl-3 col-sm-6">
              <div className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp">
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div className={styles.twoColumns}>
                      <div className="col">
                        <div className={styles.fontMediumBold}>Total Deposit</div>
                        <p>${walletData?.totalCredit || "0.00"}</p>
                      </div>
                      <div className="col">
                        <div className={styles.fontMediumBold}>Total Withdrawal</div>
                        <p>${walletData?.totalWithAmt || "0.00"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Growth Earning & Earnings Button */}
            <div className="col-xl-3 col-sm-6">
              <div className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp">
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard2} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-2">
                    <div className={styles.twoColumns}>
                      <div className="col">
                        <div className={styles.fontMediumBold}>Growth Status</div>
                        <p>{dashData?.achievements}</p>
                      </div>
                      <div className="col mt-3">
                        <button
                          className="btn btn-primary"
                          onClick={() => (window.location.href = "revenue")}
                        >
                          Earnings
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Deposit & Withdraw Buttons */}
            <div className="col-xl-3 col-sm-6">
              <div className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp">
                <div className="user-card-wrapper">
                  <div className="user-card-thumb">
                    <img src={userCard3} alt="invest icon" />
                  </div>
                  <div className="user-card-content mt-4">
                    <div className={styles.twoColumns}>
                      <div className="col">
                        <button
                          className="btn btn-success"
                          onClick={() => (window.location.href = "/wallet")}
                        >
                          Deposit
                        </button>
                      </div>
                      <div className="col">
                        <button
                          className="btn btn-danger"
                          onClick={() => (window.location.href = "/wallet")}
                        >
                          Withdraw
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* User Info & Active Package */}
            <div className="col-xl-3 col-sm-6">
              <div className="single-user-ditails-card single-user-ditails-card--style2 mb-4 mb-xl-0 wow fadeInUp">
                <div className="user-card-wrapper">
                  <div className="user-card-content mt-2">
                    <div className="small">User Name: {user?.name}</div>
                    <div className="mb-2">User ID: {user?.referral_id}</div>
                    {activeUserPackages?.length > 0 ? (
                      <>
                        <div className={styles.fontMediumBold}>
                          Active Package: {pkgName} {pkgAmount}
                        </div>
                        <div className={styles.fontMediumBold}>
                          Activation Date: {activationDate}
                        </div>
                      </>
                    ) : (
                      <div className="fs-6 text-bg-danger text-white text-center p-2 rounded">
                        No Active Package
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default UserData;
